<template>
  <div>
    <el-container class="keyPersonnelBase">
      <el-card class="tabs-card">
        <el-form
          :inline="true"
          ref="formRef"
          :model="tableParams"
          class="demo-form-inline"
        >
          <!-- <el-form-item label="设施类别" prop="syxz">
            <h-selectcode
              type="facilityType"
              v-model="tableParams.syxz"
              placeholder="设施类别"
              :clearable="true"
            ></h-selectcode>
          </el-form-item>
          <el-form-item>
            <h-button type="primary" @click="refreshTable">查询</h-button>
            <h-button @click="resetForm(formRef)">重置</h-button>
          </el-form-item> -->
          <el-row>
            <el-col>
              <h-button type="primary" @click="addButton">新建</h-button>
              <h-button
                type="danger"
                @click="delUser"
                :disabled="!tableSelection.length"
                >删除</h-button
              >
              <!-- <h-button type="primary">导入</h-button>
              <h-button type="primary">导出</h-button> -->
              <h-button type="primary" @click="refreshTable">查询</h-button>
            </el-col>
          </el-row>
        </el-form>
        <div class="table-box">
          <h-table
            ref="tableRef"
            v-model:data="tableData"
            v-model:columns="columns"
            :method="basepeoplelist"
            :params="tableParams"
            @handleClick="handleClick"
            @select="hzTableSelect"
          >
            <template #careLibraryName="{ row }">
              <u @click="nameCLickDialog(row)" class="table-row-name">{{
                row.libraryName
              }}</u>
            </template>
            <template #libraryFlag="{ row }">
              <span>{{ row.libraryFlag == "1" ? "人员库" : "车辆库" }}</span>
            </template>
            <template #operate="{ row }">
              <el-button size="small" @click="handleClick('edit', row)"
                >编辑</el-button
              >
              <el-button
                v-if="row.importanceFlag !== '0'"
                size="small"
                @click="handleClick('del', row)"
                >删除</el-button
              >
            </template>
          </h-table>
        </div>
      </el-card>
    </el-container>
    <el-dialog
      v-model="formVisible"
      :title="
        '信息库' + (status === 1 ? '新增' : status === 2 ? '编辑' : '详情')
      "
      width="33%"
    >
      <care-staff-add
        v-if="formVisible"
        @cancel="cancel"
        :status="status"
        :form="formRow"
      ></care-staff-add>
    </el-dialog>
    <el-dialog
      v-model="nameTableVisible"
      :title="formRow.libraryName"
      width="80%"
    >
      <name-add v-if="nameTableVisible" :form="formRow"></name-add>
    </el-dialog>
  </div>
</template>
<script>
import { defineComponent, reactive, toRefs, ref } from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import careStaffAdd from "./components/careStaffAdd";
import nameAdd from "./components/nameAdd";
import {
  basepeoplelist,
  basepeopledelete,
} from "@/api/communityCare/communityCareApi.js";

export default defineComponent({
  components: { careStaffAdd, nameAdd },
  setup() {
    const formRef = ref(null);
    const tableRef = ref(null);
    const state = reactive({
      status: 1, // 1添加2编辑3查看
      formVisible: false,
      nameTableVisible: false,
      houseTwoJZRVisible: false,
      formRow: {},
      tableParams: {
        regionId: "",
      },
      columns: [
        { type: "selection" },
        { type: "index" },
        {
          label: "库名称",
          slot: "careLibraryName",
        },
        {
          label: "库类别",
          slot: "libraryFlag",
        },
        {
          label: "库简称",
          prop: "libraryAbbreviation",
        },
        {
          label: "库类型",
          prop: "libraryTypeDict",
        },

        {
          label: "同步库编号",
          prop: "syncId",
        },
        {
          label: "同步状态",
          prop: "syncFlagDict",
        },
        {
          label: "是否重点",
          prop: "importanceFlagDict",
        },
        // {
        //   label: "创建人",
        //   prop: "userName"
        // },
        // {
        //   label: "创建时间",
        //   prop: "createTime"
        // },
        {
          label: "操作",
          slot: "operate",
          // operates: [{ name: "处理", emitKey: "edit" }]
        },
        // {
        //   type: "operate",
        //   label: "操作",
        //   width: "140px",
        //   operates: [
        //     { name: "编辑", emitKey: "edit" },
        //     { name: "删除", emitKey: "del", type: "danger" },
        //   ],
        // },
      ],
      tableData: [],
      tableSelection: [],
    });
    const methods = {
      // 添加弹框
      addButton() {
        state.status = 1;
        state.formRow = {};
        state.formVisible = true;
      },
      nameCLickDialog(row) {
        state.formRow = row;
        state.nameTableVisible = true;
      },
      // 删除
      delUser() {
        ElMessageBox.confirm("您确认要删除该人员库吗？", "删除", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(
          () => {
            const id = state.tableSelection.map((item) => {
              return item.libraryId;
            });
            methods.deleteAxios(id);
          },
          () => {}
        );
      },
      // 点击table操作按钮
      handleClick(operate, row) {
        const emitKey = operate;
        if (emitKey === "edit") {
          state.status = 2;
          state.formRow = row;
          state.formVisible = true;
        } else if (emitKey === "del") {
          ElMessageBox.confirm("您确认要删除该人员库吗？", "删除", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(
            () => {
              methods.deleteAxios([row.libraryId]);
            },
            () => {}
          );
        }
      },
      async deleteAxios(id) {
        const res = await basepeopledelete(id);
        if (res.code === 0) {
          ElMessage.success("删除成功");
          methods.refreshTable();
        }
      },
      // 当用户手动勾选数据行的 Checkbox 时触发的事件
      hzTableSelect(selection) {
        state.tableSelection = selection;
      },
      refreshTable() {
        tableRef.value && tableRef.value.refresh();
      },
      // 取消
      cancel() {
        state.formVisible = false;
        methods.refreshTable();
      },
      resetForm(formEl) {
        if (!formEl) return;
        formEl.resetFields();
      },
    };
    return {
      ...toRefs(state),
      ...methods,
      formRef,
      basepeoplelist,
      tableRef,
    };
  },
});
</script>
<style lang="scss" scoped>
.keyPersonnelBase {
  width: 100%;
  height: 100%;
  .tabs-card {
    width: 100%;
    .demo-form-inline {
      height: 7%;
    }
    .table-box {
      height: 93%;
      .table-row-name {
        cursor: pointer;
        color: #1887ff;
      }
    }
  }
}
</style>
